// (7, 23)(7, 21)(8, 18)(8, 22)(0, 24)
// Keeps the data for the label per grid type, level, and hours visible in the grids
var timeslotLabels = {
    'agenda': {
        'day': {
            '0-1': [
                { position: 'm0', label: '0' },
                { position: 'm30', label: ':30' },
                { position: 'm60', label: '1' },
            ],
            '1-2': [
                { position: 'm0', label: '1' },
                { position: 'm30', label: ':30' },
                { position: 'm60', label: '2' },
            ],
            '2-3': [
                { position: 'm0', label: '2' },
                { position: 'm30', label: ':30' },
                { position: 'm60', label: '3' },
            ],
            '3-4': [
                { position: 'm0', label: '3' },
                { position: 'm30', label: ':30' },
                { position: 'm60', label: '4' },
            ],
            '4-5': [
                { position: 'm0', label: '4' },
                { position: 'm30', label: ':30' },
                { position: 'm60', label: '5' },
            ],
            '5-6': [
                { position: 'm0', label: '5' },
                { position: 'm30', label: ':30' },
                { position: 'm60', label: '6' },
            ],
            '6-7': [
                { position: 'm0', label: '6' },
                { position: 'm30', label: ':30' },
                { position: 'm60', label: '7' },
            ],
            '7-8': [
                { position: 'm0', label: '7' },
                { position: 'm30', label: ':30' },
                { position: 'm60', label: '8' },
            ],
            '8-9': [
                { position: 'm0', label: '8' },
                { position: 'm30', label: ':30' },
                { position: 'm60', label: '9' },
            ],
            '9-10': [
                { position: 'm0', label: '9' },
                { position: 'm30', label: ':30' },
                { position: 'm60', label: '10' },
            ],
            '10-11': [
                { position: 'm0', label: '10' },
                { position: 'm30', label: ':30' },
                { position: 'm60', label: '11' },
            ],
            '11-12': [
                { position: 'm0', label: '11' },
                { position: 'm30', label: ':30' },
                { position: 'm60', label: '12' },
            ],
            '12-13': [
                { position: 'm0', label: '12' },
                { position: 'm30', label: ':30' },
                { position: 'm60', label: '13' },
            ],
            '13-14': [
                { position: 'm0', label: '13' },
                { position: 'm30', label: ':30' },
                { position: 'm60', label: '14' },
            ],
            '14-15': [
                { position: 'm0', label: '14' },
                { position: 'm30', label: ':30' },
                { position: 'm60', label: '15' },
            ],
            '15-16': [
                { position: 'm0', label: '15' },
                { position: 'm30', label: ':30' },
                { position: 'm60', label: '16' },
            ],
            '16-17': [
                { position: 'm0', label: '16' },
                { position: 'm30', label: ':30' },
                { position: 'm60', label: '17' },
            ],
            '17-18': [
                { position: 'm0', label: '17' },
                { position: 'm30', label: ':30' },
                { position: 'm60', label: '18' },
            ],
            '18-19': [
                { position: 'm0', label: '18' },
                { position: 'm30', label: ':30' },
                { position: 'm60', label: '19' },
            ],
            '19-20': [
                { position: 'm0', label: '19' },
                { position: 'm30', label: ':30' },
                { position: 'm60', label: '20' },
            ],
            '20-21': [
                { position: 'm0', label: '20' },
                { position: 'm30', label: ':30' },
                { position: 'm60', label: '21' },
            ],
            '21-22': [
                { position: 'm0', label: '21' },
                { position: 'm30', label: ':30' },
                { position: 'm60', label: '22' },
            ],
            '22-23': [
                { position: 'm0', label: '22' },
                { position: 'm30', label: ':30' },
                { position: 'm60', label: '23' },
            ],
            '23-24': [
                { position: 'm0', label: '23' },
                { position: 'm30', label: ':30' },
                { position: 'm60', label: '24' },
            ]
        },
        'week': {
            '0-24': [
                { position: 'h0', label: '0' },
                { position: 'h1', label: '1' },
                { position: 'h2', label: '2' },
                { position: 'h3', label: '3' },
                { position: 'h4', label: '4' },
                { position: 'h5', label: '5' },
                { position: 'h6', label: '6' },
                { position: 'h7', label: '7' },
                { position: 'h8', label: '8' },
                { position: 'h9', label: '9' },
                { position: 'h10', label: '10' },
                { position: 'h11', label: '11' },
                { position: 'h12', label: '12' },
                { position: 'h13', label: '13' },
                { position: 'h14', label: '14' },
                { position: 'h15', label: '15' },
                { position: 'h16', label: '16' },
                { position: 'h17', label: '17' },
                { position: 'h18', label: '18' },
                { position: 'h19', label: '19' },
                { position: 'h20', label: '20' },
                { position: 'h21', label: '21' },
                { position: 'h22', label: '22' },
                { position: 'h23', label: '23' },
                { position: 'h24', label: '24' }
            ],
            '7-21': [
                { position: 'h7', label: '7' },
                { position: 'h8', label: '8' },
                { position: 'h9', label: '9' },
                { position: 'h10', label: '10' },
                { position: 'h11', label: '11' },
                { position: 'h12', label: '12' },
                { position: 'h13', label: '13' },
                { position: 'h14', label: '14' },
                { position: 'h15', label: '15' },
                { position: 'h16', label: '16' },
                { position: 'h17', label: '17' },
                { position: 'h18', label: '18' },
                { position: 'h19', label: '19' },
                { position: 'h20', label: '20' },
                { position: 'h21', label: '21' }
            ],
            '8-18': [
                { position: 'h8', label: '8' },
                { position: 'h9', label: '9' },
                { position: 'h10', label: '10' },
                { position: 'h11', label: '11' },
                { position: 'h12', label: '12' },
                { position: 'h13', label: '13' },
                { position: 'h14', label: '14' },
                { position: 'h15', label: '15' },
                { position: 'h16', label: '16' },
                { position: 'h17', label: '17' },
                { position: 'h18', label: '18' }
            ],
            '8-22': [
                { position: 'h8', label: '8' },
                { position: 'h9', label: '9' },
                { position: 'h10', label: '10' },
                { position: 'h11', label: '11' },
                { position: 'h12', label: '12' },
                { position: 'h13', label: '13' },
                { position: 'h14', label: '14' },
                { position: 'h15', label: '15' },
                { position: 'h16', label: '16' },
                { position: 'h17', label: '17' },
                { position: 'h18', label: '18' },
                { position: 'h19', label: '19' },
                { position: 'h20', label: '20' },
                { position: 'h21', label: '21' },
                { position: 'h22', label: '22' }
            ],
            '7-23': [
                { position: 'h7', label: '7' },
                { position: 'h8', label: '8' },
                { position: 'h9', label: '9' },
                { position: 'h10', label: '10' },
                { position: 'h11', label: '11' },
                { position: 'h12', label: '12' },
                { position: 'h13', label: '13' },
                { position: 'h14', label: '14' },
                { position: 'h15', label: '15' },
                { position: 'h16', label: '16' },
                { position: 'h17', label: '17' },
                { position: 'h18', label: '18' },
                { position: 'h19', label: '19' },
                { position: 'h20', label: '20' },
                { position: 'h21', label: '21' },
                { position: 'h22', label: '22' },
                { position: 'h23', label: '23' }
            ]
        },
        'month': {
            '0-24': [],
            '7-21': [],
            '7-23': []
        },
        'quarter': {
            '0-24': [],
            '7-21': [],
            '7-23': []
        }
    },
    'planboard': {
        'day': {
            '0-24': [
                { position: 'h0', label: '0' },
                { position: 'h1', label: '1' },
                { position: 'h2', label: '2' },
                { position: 'h3', label: '3' },
                { position: 'h4', label: '4' },
                { position: 'h5', label: '5' },
                { position: 'h6', label: '6' },
                { position: 'h7', label: '7' },
                { position: 'h8', label: '8' },
                { position: 'h9', label: '9' },
                { position: 'h10', label: '10' },
                { position: 'h11', label: '11' },
                { position: 'h12', label: '12' },
                { position: 'h13', label: '13' },
                { position: 'h14', label: '14' },
                { position: 'h15', label: '15' },
                { position: 'h16', label: '16' },
                { position: 'h17', label: '17' },
                { position: 'h18', label: '18' },
                { position: 'h19', label: '19' },
                { position: 'h20', label: '20' },
                { position: 'h21', label: '21' },
                { position: 'h22', label: '22' },
                { position: 'h23', label: '23' },
                { position: 'h24', label: '24' }
            ],
            '7-21': [
                { position: 'h7', label: '7' },
                { position: 'h8', label: '8' },
                { position: 'h9', label: '9' },
                { position: 'h10', label: '10' },
                { position: 'h11', label: '11' },
                { position: 'h12', label: '12' },
                { position: 'h13', label: '13' },
                { position: 'h14', label: '14' },
                { position: 'h15', label: '15' },
                { position: 'h16', label: '16' },
                { position: 'h17', label: '17' },
                { position: 'h18', label: '18' },
                { position: 'h19', label: '19' },
                { position: 'h20', label: '20' },
                { position: 'h21', label: '21' }
            ],
            '8-18': [
                { position: 'h8', label: '8' },
                { position: 'h9', label: '9' },
                { position: 'h10', label: '10' },
                { position: 'h11', label: '11' },
                { position: 'h12', label: '12' },
                { position: 'h13', label: '13' },
                { position: 'h14', label: '14' },
                { position: 'h15', label: '15' },
                { position: 'h16', label: '16' },
                { position: 'h17', label: '17' },
                { position: 'h18', label: '18' }
            ],
            '8-22': [
                { position: 'h8', label: '8' },
                { position: 'h9', label: '9' },
                { position: 'h10', label: '10' },
                { position: 'h11', label: '11' },
                { position: 'h12', label: '12' },
                { position: 'h13', label: '13' },
                { position: 'h14', label: '14' },
                { position: 'h15', label: '15' },
                { position: 'h16', label: '16' },
                { position: 'h17', label: '17' },
                { position: 'h18', label: '18' },
                { position: 'h19', label: '19' },
                { position: 'h20', label: '20' },
                { position: 'h21', label: '21' },
                { position: 'h22', label: '22' }
            ],
            '7-23': [
                { position: 'h7', label: '7' },
                { position: 'h8', label: '8' },
                { position: 'h9', label: '9' },
                { position: 'h10', label: '10' },
                { position: 'h11', label: '11' },
                { position: 'h12', label: '12' },
                { position: 'h13', label: '13' },
                { position: 'h14', label: '14' },
                { position: 'h15', label: '15' },
                { position: 'h16', label: '16' },
                { position: 'h17', label: '17' },
                { position: 'h18', label: '18' },
                { position: 'h19', label: '19' },
                { position: 'h20', label: '20' },
                { position: 'h21', label: '21' },
                { position: 'h22', label: '22' },
                { position: 'h23', label: '23' }
            ]
        },
        'week': {
            '0-24': [
                { position: 'h0', label: '0' },
                { position: 'h24', label: '24' }
            ],
            '7-21': [
                { position: 'h7', label: '7' },
                { position: 'h14', label: '14' },
                { position: 'h21', label: '21' }
            ],
            '8-18': [
                { position: 'h8', label: '8' },
                { position: 'h13', label: '13' },
                { position: 'h18', label: '18' }
            ],
            '8-22': [
                { position: 'h8', label: '8' },
                { position: 'h15', label: '15' },
                { position: 'h22', label: '22' }
            ],
            '7-23': [
                { position: 'h7', label: '7' },
                { position: 'h15', label: '15' },
                { position: 'h23', label: '23' }
            ]
        },
        'month': {
            '0-24': [],
            '7-21': [],
            '7-23': []
        },
        'quarter': {
            '0-24': [],
            '7-21': [],
            '7-23': []
        }
    }
};
// Keeps the data for the dots per grid type, level, and hours visible in the grids
var timeslotDots = {
    'agenda': {
        'day': {
            '0-1': [
                { position: 'm0', variant: 'primary' },
                { position: 'm15', variant: 'secondary' },
                { position: 'm30', variant: 'primary' },
                { position: 'm45', variant: 'secondary' },
                { position: 'm60', variant: 'primary' }
            ],
            '1-2': [
                { position: 'm0', variant: 'primary' },
                { position: 'm15', variant: 'secondary' },
                { position: 'm30', variant: 'primary' },
                { position: 'm45', variant: 'secondary' },
                { position: 'm60', variant: 'primary' }
            ],
            '2-3': [
                { position: 'm0', variant: 'primary' },
                { position: 'm15', variant: 'secondary' },
                { position: 'm30', variant: 'primary' },
                { position: 'm45', variant: 'secondary' },
                { position: 'm60', variant: 'primary' }
            ],
            '3-4': [
                { position: 'm0', variant: 'primary' },
                { position: 'm15', variant: 'secondary' },
                { position: 'm30', variant: 'primary' },
                { position: 'm45', variant: 'secondary' },
                { position: 'm60', variant: 'primary' }
            ],
            '4-5': [
                { position: 'm0', variant: 'primary' },
                { position: 'm15', variant: 'secondary' },
                { position: 'm30', variant: 'primary' },
                { position: 'm45', variant: 'secondary' },
                { position: 'm60', variant: 'primary' }
            ],
            '5-6': [
                { position: 'm0', variant: 'primary' },
                { position: 'm15', variant: 'secondary' },
                { position: 'm30', variant: 'primary' },
                { position: 'm45', variant: 'secondary' },
                { position: 'm60', variant: 'primary' }
            ],
            '6-7': [
                { position: 'm0', variant: 'primary' },
                { position: 'm15', variant: 'secondary' },
                { position: 'm30', variant: 'primary' },
                { position: 'm45', variant: 'secondary' },
                { position: 'm60', variant: 'primary' }
            ],
            '7-8': [
                { position: 'm0', variant: 'primary' },
                { position: 'm15', variant: 'secondary' },
                { position: 'm30', variant: 'primary' },
                { position: 'm45', variant: 'secondary' },
                { position: 'm60', variant: 'primary' }
            ],
            '8-9': [
                { position: 'm0', variant: 'primary' },
                { position: 'm15', variant: 'secondary' },
                { position: 'm30', variant: 'primary' },
                { position: 'm45', variant: 'secondary' },
                { position: 'm60', variant: 'primary' }
            ],
            '9-10': [
                { position: 'm0', variant: 'primary' },
                { position: 'm15', variant: 'secondary' },
                { position: 'm30', variant: 'primary' },
                { position: 'm45', variant: 'secondary' },
                { position: 'm60', variant: 'primary' }
            ],
            '10-11': [
                { position: 'm0', variant: 'primary' },
                { position: 'm15', variant: 'secondary' },
                { position: 'm30', variant: 'primary' },
                { position: 'm45', variant: 'secondary' },
                { position: 'm60', variant: 'primary' }
            ],
            '11-12': [
                { position: 'm0', variant: 'primary' },
                { position: 'm15', variant: 'secondary' },
                { position: 'm30', variant: 'primary' },
                { position: 'm45', variant: 'secondary' },
                { position: 'm60', variant: 'primary' }
            ],
            '12-13': [
                { position: 'm0', variant: 'primary' },
                { position: 'm15', variant: 'secondary' },
                { position: 'm30', variant: 'primary' },
                { position: 'm45', variant: 'secondary' },
                { position: 'm60', variant: 'primary' }
            ],
            '13-14': [
                { position: 'm0', variant: 'primary' },
                { position: 'm15', variant: 'secondary' },
                { position: 'm30', variant: 'primary' },
                { position: 'm45', variant: 'secondary' },
                { position: 'm60', variant: 'primary' }
            ],
            '14-15': [
                { position: 'm0', variant: 'primary' },
                { position: 'm15', variant: 'secondary' },
                { position: 'm30', variant: 'primary' },
                { position: 'm45', variant: 'secondary' },
                { position: 'm60', variant: 'primary' }
            ],
            '15-16': [
                { position: 'm0', variant: 'primary' },
                { position: 'm15', variant: 'secondary' },
                { position: 'm30', variant: 'primary' },
                { position: 'm45', variant: 'secondary' },
                { position: 'm60', variant: 'primary' }
            ],
            '16-17': [
                { position: 'm0', variant: 'primary' },
                { position: 'm15', variant: 'secondary' },
                { position: 'm30', variant: 'primary' },
                { position: 'm45', variant: 'secondary' },
                { position: 'm60', variant: 'primary' }
            ],
            '17-18': [
                { position: 'm0', variant: 'primary' },
                { position: 'm15', variant: 'secondary' },
                { position: 'm30', variant: 'primary' },
                { position: 'm45', variant: 'secondary' },
                { position: 'm60', variant: 'primary' }
            ],
            '18-19': [
                { position: 'm0', variant: 'primary' },
                { position: 'm15', variant: 'secondary' },
                { position: 'm30', variant: 'primary' },
                { position: 'm45', variant: 'secondary' },
                { position: 'm60', variant: 'primary' }
            ],
            '19-20': [
                { position: 'm0', variant: 'primary' },
                { position: 'm15', variant: 'secondary' },
                { position: 'm30', variant: 'primary' },
                { position: 'm45', variant: 'secondary' },
                { position: 'm60', variant: 'primary' }
            ],
            '20-21': [
                { position: 'm0', variant: 'primary' },
                { position: 'm15', variant: 'secondary' },
                { position: 'm30', variant: 'primary' },
                { position: 'm45', variant: 'secondary' },
                { position: 'm60', variant: 'primary' }
            ],
            '21-22': [
                { position: 'm0', variant: 'primary' },
                { position: 'm15', variant: 'secondary' },
                { position: 'm30', variant: 'primary' },
                { position: 'm45', variant: 'secondary' },
                { position: 'm60', variant: 'primary' }
            ],
            '22-23': [
                { position: 'm0', variant: 'primary' },
                { position: 'm15', variant: 'secondary' },
                { position: 'm30', variant: 'primary' },
                { position: 'm45', variant: 'secondary' },
                { position: 'm60', variant: 'primary' }
            ],
            '23-24': [
                { position: 'm0', variant: 'primary' },
                { position: 'm15', variant: 'secondary' },
                { position: 'm30', variant: 'primary' },
                { position: 'm45', variant: 'secondary' },
                { position: 'm60', variant: 'primary' }
            ]
        },
        'week': {
            '0-24': [
                { position: 'h0', variant: 'primary' },
                { position: 'h1', variant: 'primary' },
                { position: 'h2', variant: 'primary' },
                { position: 'h3', variant: 'primary' },
                { position: 'h4', variant: 'primary' },
                { position: 'h5', variant: 'primary' },
                { position: 'h6', variant: 'primary' },
                { position: 'h7', variant: 'primary' },
                { position: 'h8', variant: 'primary' },
                { position: 'h9', variant: 'primary' },
                { position: 'h10', variant: 'primary' },
                { position: 'h11', variant: 'primary' },
                { position: 'h12', variant: 'primary' },
                { position: 'h13', variant: 'primary' },
                { position: 'h14', variant: 'primary' },
                { position: 'h15', variant: 'primary' },
                { position: 'h16', variant: 'primary' },
                { position: 'h17', variant: 'primary' },
                { position: 'h18', variant: 'primary' },
                { position: 'h19', variant: 'primary' },
                { position: 'h20', variant: 'primary' },
                { position: 'h21', variant: 'primary' },
                { position: 'h22', variant: 'primary' },
                { position: 'h23', variant: 'primary' },
                { position: 'h24', variant: 'primary' }
            ],
            '7-21': [
                { position: 'h7', variant: 'primary' },
                { position: 'h8', variant: 'primary' },
                { position: 'h9', variant: 'primary' },
                { position: 'h10', variant: 'primary' },
                { position: 'h11', variant: 'primary' },
                { position: 'h12', variant: 'primary' },
                { position: 'h13', variant: 'primary' },
                { position: 'h14', variant: 'primary' },
                { position: 'h15', variant: 'primary' },
                { position: 'h16', variant: 'primary' },
                { position: 'h17', variant: 'primary' },
                { position: 'h18', variant: 'primary' },
                { position: 'h19', variant: 'primary' },
                { position: 'h20', variant: 'primary' },
                { position: 'h21', variant: 'primary' }
            ],
            '8-18': [
                { position: 'h8', variant: 'primary' },
                { position: 'h9', variant: 'primary' },
                { position: 'h10', variant: 'primary' },
                { position: 'h11', variant: 'primary' },
                { position: 'h12', variant: 'primary' },
                { position: 'h13', variant: 'primary' },
                { position: 'h14', variant: 'primary' },
                { position: 'h15', variant: 'primary' },
                { position: 'h16', variant: 'primary' },
                { position: 'h17', variant: 'primary' },
                { position: 'h18', variant: 'primary' }
            ],
            '8-22': [
                { position: 'h8', variant: 'primary' },
                { position: 'h9', variant: 'primary' },
                { position: 'h10', variant: 'primary' },
                { position: 'h11', variant: 'primary' },
                { position: 'h12', variant: 'primary' },
                { position: 'h13', variant: 'primary' },
                { position: 'h14', variant: 'primary' },
                { position: 'h15', variant: 'primary' },
                { position: 'h16', variant: 'primary' },
                { position: 'h17', variant: 'primary' },
                { position: 'h18', variant: 'primary' },
                { position: 'h19', variant: 'primary' },
                { position: 'h20', variant: 'primary' },
                { position: 'h21', variant: 'primary' },
                { position: 'h22', variant: 'primary' }
            ],
            '7-23': [
                { position: 'h7', variant: 'primary' },
                { position: 'h8', variant: 'primary' },
                { position: 'h9', variant: 'primary' },
                { position: 'h10', variant: 'primary' },
                { position: 'h11', variant: 'primary' },
                { position: 'h12', variant: 'primary' },
                { position: 'h13', variant: 'primary' },
                { position: 'h14', variant: 'primary' },
                { position: 'h15', variant: 'primary' },
                { position: 'h16', variant: 'primary' },
                { position: 'h17', variant: 'primary' },
                { position: 'h18', variant: 'primary' },
                { position: 'h19', variant: 'primary' },
                { position: 'h20', variant: 'primary' },
                { position: 'h21', variant: 'primary' },
                { position: 'h22', variant: 'primary' },
                { position: 'h23', variant: 'primary' }
            ]
        },
        'month': {
            '0-24': [],
            '7-21': [],
            '7-23': []
        },
        'quarter': {
            '0-24': [],
            '7-21': [],
            '7-23': []
        }
    },
    'planboard': {
        'day': {
            '0-24': [
                { position: 'h0', variant: 'primary' },
                { position: 'h1', variant: 'primary' },
                { position: 'h2', variant: 'primary' },
                { position: 'h3', variant: 'primary' },
                { position: 'h4', variant: 'primary' },
                { position: 'h5', variant: 'primary' },
                { position: 'h6', variant: 'primary' },
                { position: 'h7', variant: 'primary' },
                { position: 'h8', variant: 'primary' },
                { position: 'h9', variant: 'primary' },
                { position: 'h10', variant: 'primary' },
                { position: 'h11', variant: 'primary' },
                { position: 'h12', variant: 'primary' },
                { position: 'h13', variant: 'primary' },
                { position: 'h14', variant: 'primary' },
                { position: 'h15', variant: 'primary' },
                { position: 'h16', variant: 'primary' },
                { position: 'h17', variant: 'primary' },
                { position: 'h18', variant: 'primary' },
                { position: 'h19', variant: 'primary' },
                { position: 'h20', variant: 'primary' },
                { position: 'h21', variant: 'primary' },
                { position: 'h22', variant: 'primary' },
                { position: 'h23', variant: 'primary' },
                { position: 'h24', variant: 'primary' }
            ],
            '7-21': [
                { position: 'h7', variant: 'primary' },
                { position: 'h8', variant: 'primary' },
                { position: 'h9', variant: 'primary' },
                { position: 'h10', variant: 'primary' },
                { position: 'h11', variant: 'primary' },
                { position: 'h12', variant: 'primary' },
                { position: 'h13', variant: 'primary' },
                { position: 'h14', variant: 'primary' },
                { position: 'h15', variant: 'primary' },
                { position: 'h16', variant: 'primary' },
                { position: 'h17', variant: 'primary' },
                { position: 'h18', variant: 'primary' },
                { position: 'h19', variant: 'primary' },
                { position: 'h20', variant: 'primary' },
                { position: 'h21', variant: 'primary' }
            ],
            '8-18': [
                { position: 'h8', variant: 'primary' },
                { position: 'h9', variant: 'primary' },
                { position: 'h10', variant: 'primary' },
                { position: 'h11', variant: 'primary' },
                { position: 'h12', variant: 'primary' },
                { position: 'h13', variant: 'primary' },
                { position: 'h14', variant: 'primary' },
                { position: 'h15', variant: 'primary' },
                { position: 'h16', variant: 'primary' },
                { position: 'h17', variant: 'primary' },
                { position: 'h18', variant: 'primary' }
            ],
            '8-22': [
                { position: 'h8', variant: 'primary' },
                { position: 'h9', variant: 'primary' },
                { position: 'h10', variant: 'primary' },
                { position: 'h11', variant: 'primary' },
                { position: 'h12', variant: 'primary' },
                { position: 'h13', variant: 'primary' },
                { position: 'h14', variant: 'primary' },
                { position: 'h15', variant: 'primary' },
                { position: 'h16', variant: 'primary' },
                { position: 'h17', variant: 'primary' },
                { position: 'h18', variant: 'primary' },
                { position: 'h19', variant: 'primary' },
                { position: 'h20', variant: 'primary' },
                { position: 'h21', variant: 'primary' },
                { position: 'h22', variant: 'primary' }
            ],
            '7-23': [
                { position: 'h7', variant: 'primary' },
                { position: 'h8', variant: 'primary' },
                { position: 'h9', variant: 'primary' },
                { position: 'h10', variant: 'primary' },
                { position: 'h11', variant: 'primary' },
                { position: 'h12', variant: 'primary' },
                { position: 'h13', variant: 'primary' },
                { position: 'h14', variant: 'primary' },
                { position: 'h15', variant: 'primary' },
                { position: 'h16', variant: 'primary' },
                { position: 'h17', variant: 'primary' },
                { position: 'h18', variant: 'primary' },
                { position: 'h19', variant: 'primary' },
                { position: 'h20', variant: 'primary' },
                { position: 'h21', variant: 'primary' },
                { position: 'h22', variant: 'primary' },
                { position: 'h23', variant: 'primary' }
            ]
        },
        'week': {
            '0-24': [
                { position: 'h0', variant: 'primary' },
                { position: 'h12', variant: 'secondary' },
                { position: 'h24', variant: 'primary' }
            ],
            '7-21': [
                { position: 'h7', variant: 'primary' },
                { position: 'h14', variant: 'primary' },
                { position: 'h21', variant: 'primary' }
            ],
            '8-18': [
                { position: 'h8', variant: 'primary' },
                { position: 'h13', variant: 'primary' },
                { position: 'h18', variant: 'primary' }
            ],
            '8-22': [
                { position: 'h8', variant: 'primary' },
                { position: 'h15', variant: 'primary' },
                { position: 'h22', variant: 'primary' }
            ],
            '7-23': [
                { position: 'h7', variant: 'primary' },
                { position: 'h15', variant: 'primary' },
                { position: 'h23', variant: 'primary' }
            ]
        },
        'month': {
            '0-24': [],
            '7-21': [],
            '7-23': []
        },
        'quarter': {
            '0-24': [],
            '7-21': [],
            '7-23': []
        }
    }
};
// Keeps the data for the splitters per grid type, level, and hours visible in the grids
var timeslotSplitters = {
    'agenda': {
        'day': {
            '0-24': [
                { position: 'm30' },
            ],
            '7-21': [
                { position: 'm30' },
            ],
            '7-23': [
                { position: 'm30' },
            ]
        },
        'week': {
            '0-24': [
                { position: 'h4' },
                { position: 'h8' },
                { position: 'h12' },
                { position: 'h16' },
                { position: 'h20' }
            ],
            '8-18': [
                { position: 'h10' },
                { position: 'h12' },
                { position: 'h14' },
                { position: 'h16' },
            ],
            '8-22': [
                { position: 'h10' },
                { position: 'h12' },
                { position: 'h14' },
                { position: 'h16' },
                { position: 'h18' },
                { position: 'h20' }
            ],
            '7-21': [
                { position: 'h11', label: '11' },
                { position: 'h17', label: '17' }
            ],
            '7-23': [
                { position: 'h11' },
                { position: 'h15' },
                { position: 'h19' }
            ]
        },
        'month': {
            '0-24': [],
            '7-21': [],
            '7-23': []
        },
        'quarter': {
            '0-24': [],
            '7-21': [],
            '7-23': []
        }
    },
    'planboard': {
        'day': {
            '0-24': [
                { position: 'h4' },
                { position: 'h8' },
                { position: 'h12' },
                { position: 'h16' },
                { position: 'h20' }
            ],
            '7-21': [
                { position: 'h11' },
                { position: 'h17' },
                { position: 'h21' }
            ],
            '8-18': [
                { position: 'h10' },
                { position: 'h12' },
                { position: 'h14' },
                { position: 'h16' },
            ],
            '8-22': [
                { position: 'h10' },
                { position: 'h12' },
                { position: 'h14' },
                { position: 'h16' },
                { position: 'h18' },
                { position: 'h20' }
            ],
            '7-23': [
                { position: 'h11' },
                { position: 'h15' },
                { position: 'h19' }
            ]
        },
        'week': {
            '0-24': [
                { position: 'h12' }
            ],
            '7-21': [
                { position: 'h14' },
            ],
            '8-18': [
                { position: 'h13' }
            ],
            '8-22': [
                { position: 'h15' }
            ],
            '7-23': [
                { position: 'h15' },
            ]
        },
        'month': {
            '0-24': [],
            '7-21': [],
            '8-18': [],
            '8-22': [],
            '7-23': []
        },
        'quarter': {
            '0-24': [],
            '7-21': [],
            '8-18': [],
            '8-22': [],
            '7-23': []
        }
    }
};
/**
 * Used for storing the data for timeslot decorations such as labels, splitters, and dots.
 *
 * @export
 * @class TimeslotDecorations
 */
var TimeslotDecorations = /** @class */ (function () {
    /**
    * Creates an instance of TimeslotDecorations.
    * @param {string} gridType
    * @param {DetailLevel} detailLevel
    * @param {number} visibleHourStart
    * @param {number} visibleHoursEnd
    */
    function TimeslotDecorations(gridType, detailLevel, visibleHourStart, visibleHoursEnd) {
        this.gridType = gridType;
        this.detailLevel = detailLevel;
        this.visibleHourStart = visibleHourStart;
        this.visibleHoursEnd = visibleHoursEnd;
    }
    /**
     * Get the dots for given grid type, level and visible hours
     * @returns {GridDot[]}
     */
    TimeslotDecorations.prototype.getDots = function () {
        // If grid type does not exists return empty array
        if (!timeslotDots[this.gridType]) {
            return [];
        }
        // If level does not exists return empty array
        if (!timeslotDots[this.gridType][this.detailLevel.name]) {
            return [];
        }
        // If start / end does not exists return empty array
        if (!timeslotDots[this.gridType][this.detailLevel.name][this.visibleHourStart + '-' + this.visibleHoursEnd]) {
            return [];
        }
        // Return the dots
        return timeslotDots[this.gridType][this.detailLevel.name][this.visibleHourStart + '-' + this.visibleHoursEnd];
    };
    /**
     * Get the splitters for given grid type, level and visible hours
     *
     * @returns {GridSplitter[]}
     */
    TimeslotDecorations.prototype.getSplitters = function () {
        // If grid type does not exists return empty array
        if (!timeslotSplitters[this.gridType]) {
            return [];
        }
        // If level does not exists return empty array
        if (!timeslotSplitters[this.gridType][this.detailLevel.name]) {
            return [];
        }
        // If start / end does not exists return empty array
        if (!timeslotSplitters[this.gridType][this.detailLevel.name][this.visibleHourStart + '-' + this.visibleHoursEnd]) {
            return [];
        }
        // Return the dots
        return timeslotSplitters[this.gridType][this.detailLevel.name][this.visibleHourStart + '-' + this.visibleHoursEnd];
    };
    /**
     * Get the labels for given grid type, level and visible hours
     *
     * @returns {GridLabel[]}
     */
    TimeslotDecorations.prototype.getLabels = function () {
        // If grid type does not exists return empty array
        if (!timeslotLabels[this.gridType]) {
            return [];
        }
        // If level does not exists return empty array
        if (!timeslotLabels[this.gridType][this.detailLevel.name]) {
            return [];
        }
        // If start / end does not exists return empty array
        if (!timeslotLabels[this.gridType][this.detailLevel.name][this.visibleHourStart + '-' + this.visibleHoursEnd]) {
            return [];
        }
        // Return the dots
        return timeslotLabels[this.gridType][this.detailLevel.name][this.visibleHourStart + '-' + this.visibleHoursEnd];
    };
    return TimeslotDecorations;
}());
export { TimeslotDecorations };
